import { NextUIProvider } from '@nextui-org/system'
import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet, ScrollRestoration, useRouter } from '@tanstack/react-router'
import * as React from 'react'
import { Suspense, useCallback } from 'react'

import { RouteNavigationListener } from '~in-app/components'
import { ToastifyProvider } from '~in-app/components/toastify'

const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null // Render nothing in production
  : React.lazy(() =>
    // Lazy load in development
      import('@tanstack/router-devtools').then(res => ({
        default: res.TanStackRouterDevtools,
      // For Embedded Mode
      // default: res.TanStackRouterDevtoolsPanel
      })),
    )

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
  staticData: {
    privileges: [],
  },
})

function Root() {
  const router = useRouter()

  const navigate = useCallback((path: string) => {
    router.navigate({
      to: path,
    })
  }, [])

  return (
    <NextUIProvider navigate={navigate}>
      <RouteNavigationListener />

      <div className="min-h-screen bg-background font-roboto">
        <ToastifyProvider />
        <ScrollRestoration />
        <Outlet />
      </div>

      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
    </NextUIProvider>
  )
}
